import { render, staticRenderFns } from "./table-retorno-pix.vue?vue&type=template&id=29021ae4&scoped=true&"
import script from "./table-retorno-pix.vue?vue&type=script&lang=js&"
export * from "./table-retorno-pix.vue?vue&type=script&lang=js&"
import style0 from "./table-retorno-pix.vue?vue&type=style&index=0&id=29021ae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29021ae4",
  null
  
)

export default component.exports